import Cookies from "js-cookie";
import axios from "axios";
import { urls } from "@/public/utils/env";

class RefreshToken {
    refreshToken: string = "";
    accessToken: string = "";
    userInfo: any;
    refreshAccessCallback: Function;
    expireCallback: Function;
    interval: number = 0;

    constructor(obj) {
        this.refreshAccessCallback = obj && obj.callback;
    }
    setCallback(callback: Function, expire: Function) {
        this.refreshAccessCallback = callback;
        this.expireCallback = expire;
    }

    checkLocalCookie() {
        let userInfo = Cookies.getJSON("EDCurrent");
        if (userInfo) {
            this.accessToken = userInfo.access_token;
            this.refreshToken = userInfo.refresh_token;
            this.userInfo = userInfo;
            return Promise.resolve();
        }
        return Promise.reject();
    }

    validRefreshToken() {
        return axios.get(`${urls.apiUrl}/api/user/user/valid`, {
            headers: {
                Authorization: "Bearer " + this.refreshToken,
            },
        });
    }

    refreshAccessToken() {
        return axios
            .put(
                `${urls.apiUrl}/api/user/user/refresh_token`,
                {},
                {
                    headers: {
                        Authorization: "Bearer " + this.refreshToken,
                    },
                }
            )
            .then((e) => {
                let data = e.data.data;
                this.userInfo.access_token = data.access_token;
                this.userInfo.token = data.access_token;
                this.refreshAccessCallback && this.refreshAccessCallback(data.access_token);
            })
            .catch(() => {
                clearInterval(this.interval);
                this.expireCallback && this.expireCallback();
            });
    }

    addInterval() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setInterval(() => {
            this.refreshAccessToken();
        }, 10 * 60 * 1000);
    }

    loginInterval(userInfo: any) {
        // 用于登录后不刷新界面场景，主动添加定时器
        this.accessToken = userInfo.access_token;
        this.refreshToken = userInfo.refresh_token;
        this.userInfo = userInfo;
        this.addInterval();
    }

    valid() {
        return this.checkLocalCookie()
            .then(() => {
                return this.validRefreshToken();
            })
            .then(() => {
                this.addInterval();
                return this.refreshAccessToken();
            })
            .then(() => {
                return this.userInfo;
            });
    }
}
export default RefreshToken;
